/** Modal layer above drawer (1200), app bar (~1201), sticky tabs, and speed dials. */
export const APP_MODAL_Z_INDEX = 1500;

/**
 * Spread onto MUI Dialog so Modal + backdrop stack above page chrome.
 * (Dialog `sx` alone styles the Paper, not the Modal root.)
 */
export function getAppDialogProps({ paperSx } = {}) {
    return {
        disableScrollLock: false,
        sx: { zIndex: APP_MODAL_Z_INDEX },
        BackdropProps: {
            sx: {
                zIndex: APP_MODAL_Z_INDEX,
                backgroundColor: "rgba(0, 0, 0, 0.45)",
            },
        },
        PaperProps: {
            sx: {
                position: "relative",
                zIndex: APP_MODAL_Z_INDEX + 1,
                ...paperSx,
            },
        },
    };
}
